import { USERS_FILTER, USERS_TEAM_FILTER } from 'app/constants/organizations'
import { escapeSpecialSymbols } from './patternsRegExp.ts'
import { List } from 'immutable'

export const filterByTeam = (list, teamName) => {
  switch (teamName) {
    case USERS_TEAM_FILTER.ALL: {
      return list
    }
    case USERS_TEAM_FILTER.WITHOUT: {
      return list.filter(user => user.get('teams').size === 0)
    }
    default: {
      return list.filter(user => {
        return user.get('teams') && !!user.get('teams').includes(teamName)
      })
    }
  }
}

export const filterBySearh = (list, bySearch) => {
  if (!bySearch) {
    return list
  }
  return list.filter(user => {
    const searchField =
      (user.has('firstName') && user.get('firstName')) +
      (user.has('lastName') && user.get('lastName')) +
      user.get('email')
    const withOutWhiteSpacesBySearch = bySearch.replace(/\s/g, '')
    return searchField.search(new RegExp(escapeSpecialSymbols(withOutWhiteSpacesBySearch), 'i')) !== -1
  })
}

export const filterBySort = (list, by, desc) => {
  if (by) {
    if (by === 'fullName') {
      return list.sortBy(
        item => {
          const initials = `${item.get('firstName')}${item.get('lastName')}` || '--'
          return initials.toUpperCase()
        },
        (a, b) => (desc ? a.localeCompare(b) : b.localeCompare(a))
      )
    } else if (by === 'completedCount') {
      return list.sortBy(
        item => item.get('completedCount'),
        (a = 0, b = 0) => (desc ? b - a : a - b)
      )
    } else if (by === 'email') {
      return list.sortBy(
        item => item.get('email'),
        (a, b) => (desc ? a.localeCompare(b) : b.localeCompare(a))
      )
    }
  }
  return list
}

export const filterIncompleteOtherReviews = list => list.some(item => item.get('isComplete') === false)

export const filterTReady = list => list.some(item => item.get('isComplete') === true)

export const filterUsersNotProTrackPicked = users =>
  users.filter(user => user.get('invitationAccepted') === true && !user.get('userProTrackLevelId'))

export const filterUsersNotInvitationAccepted = users => users.filter(user => user.get('invitationAccepted') === false)

export const handleTotalPages = (total, perPage) => {
  return Math.ceil(total.size / perPage)
}

export const handleUsersForCurrentPage = (all, currentPage, perPage) => {
  return all.skip(currentPage * perPage).take(perPage)
}

export const takeEmailsUsersFromUsersList = users =>
  users.reduce((users, user) => users.push(user.get('email')), List())

export const handleAdminsListFiltered = (
  list,
  listNotInvitationAccepted,
  listNotProTrackPicked,
  filterBy,
  usersFilter
) => {
  const filteredUsers =
    {
      [USERS_FILTER.POST]: listNotInvitationAccepted,
      [USERS_FILTER.FIRE_OUTLINE]: listNotProTrackPicked,
    }[usersFilter] || list
  if (!filterBy) {
    return filteredUsers
  }
  return filteredUsers.filter(user => {
    const searchField =
      (user.has('firstName') && user.get('firstName')) +
      (user.has('lastName') && user.get('lastName')) +
      user.get('email')
    return searchField ? searchField.search(new RegExp(escapeSpecialSymbols(filterBy.trim()), 'i')) !== -1 : false
  })
}

export const isReadyForGenerateT1Report = user =>
  user.get('t1Self') &&
  !user.get('t1ReportCreated') &&
  (filterTReady(user.get('t1Employee')) || filterTReady(user.get('t1Superior')) || filterTReady(user.get('t1Peer')))

export const isReadyForGenerateT2Report = user =>
  user.get('t1ReportCreated') &&
  user.get('t2Self') &&
  !user.get('t2ReportCreated') &&
  (filterTReady(user.get('t2Employee')) || filterTReady(user.get('t2Superior')) || filterTReady(user.get('t2Peer')))
